<script setup>
import { computed } from 'vue';

const props = defineProps({
  status: { type: Object, required: true },
});

// Encerrado em verde/cinza, esperando o cliente em ambar para chamar a atencao
// de quem precisa responder, o resto em azul.
const colorClass = computed(() => {
  if (props.status.category === 'resolved') return 'bg-n-teal-3 text-n-teal-11';
  if (props.status.category === 'cancelled')
    return 'bg-n-slate-3 text-n-slate-11';
  if (props.status.awaitingCustomer) return 'bg-n-amber-3 text-n-amber-11';
  return 'bg-n-blue-3 text-n-blue-11';
});
</script>

<template>
  <span
    class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-md whitespace-nowrap"
    :class="colorClass"
  >
    {{ status.name }}
  </span>
</template>
